<script lang="ts">
  import { createEventDispatcher, onMount } from "svelte";
  import AdminView from './AdminView.svelte';
  import Block from './Block.svelte';

  export let props: any = null;
  export let adminView = false;

  let blockId = Math.random().toString(36).substring(2, 9);
  let containerRef: HTMLElement | null = null;

  const dispatch = createEventDispatcher();

  onMount(() => {
    // Get the block ID from the closest parent with class 'card'
    const cardElement = containerRef?.closest('.card');
    if (cardElement?.id) {
      blockId = cardElement.id;
    }
  });
</script>

{#if adminView}
  <AdminView {props} {blockId} on:keyup={(e) => dispatch("keyup", e.detail)} />
{:else}
  <Block {props} bind:containerRef />
{/if}